import { branch, inheritKey, memberKey } from './constants'
import * as classes from '.'

class ConfigQuery extends Weaver.Query

  constructor: ->
    super()
    @branchId = branch

  type: (Class) ->
    @hasRelationOut(
      memberKey,
      Class.getTypeNode()
    )

  getTypes: ->
    @restrict(
      _.keys(classes).map((key) -> "#{ key }")
    )
    .find()


export default ConfigQuery
